import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Page } from '../../../shared/models/page';
import {
  UserSummary, UserCountsResponse, UserDetail,
  CreateUserRequest, UpdateUserRequest, CompanySummary, SuperBrokerSummary, ProviderSummary,
} from './user-api.models';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.api.core}/api/v1/admin/users`;

  getCounts(): Observable<UserCountsResponse> {
    return this.http.get<UserCountsResponse>(`${this.baseUrl}/counts`);
  }

  listUsers(params: {
    role?: string;
    search?: string;
    enabled?: boolean;
    page?: number;
    pageSize?: number;
  }): Observable<Page<UserSummary>> {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value != null && value !== '') httpParams = httpParams.set(key, String(value));
    });
    return this.http.get<Page<UserSummary>>(this.baseUrl, { params: httpParams });
  }

  createUser(request: CreateUserRequest): Observable<UserDetail> {
    return this.http.post<UserDetail>(this.baseUrl, request);
  }

  getUser(userId: string): Observable<UserDetail> {
    return this.http.get<UserDetail>(`${this.baseUrl}/${userId}`);
  }

  updateUser(userId: string, request: UpdateUserRequest): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${userId}`, request);
  }

  listCompanies(): Observable<CompanySummary[]> {
    return this.http.get<CompanySummary[]>(`${this.baseUrl}/companies`);
  }

  listSuperBrokers(): Observable<SuperBrokerSummary[]> {
    return this.http.get<SuperBrokerSummary[]>(`${this.baseUrl}/super-brokers`);
  }

  listProviders(): Observable<ProviderSummary[]> {
    return this.http.get<ProviderSummary[]>(`${this.baseUrl}/providers`);
  }
}
